// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__3quQz","rotation":"Loader_rotation__1Q48B"};